import {SmartForm} from "./SmartForm";
import {submitData} from "../helpers/PreferenceCenterProxyHelper"

export const additionalFields = {
    Unsubscribed: "",
    Preferred_Topic_Workspace__c: "",
    Preferred_Topic_Analytics__c: "",
    Preferred_Topic_NetworkingADC__c: "",
    Preferred_Topic_SDWan__c: "",
    Preferred_Topic_VirtualAppsDesktops__c: "",
    Marketing_Suspended_30_Days__c: "",
}

export const additionalFieldsSchema = {
    Preferred_Topic_Workspace__c: {
        "label": "Preferred_Topic_Workspace__c",
        "show": true,
        "id": "Preferred_Topic_Workspace__c",
        "name": "Preferred_Topic_Workspace__c",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
    Preferred_Topic_Analytics__c: {
        "label": "Preferred_Topic_Analytics__c",
        "options": [
            "",
            {
                "value": "Yes",
                "text": "Yes"
            },
            {
                "value": "No",
                "text": "No"
            }
        ],
        "show": true,
        "id": "Preferred_Topic_Analytics__c",
        "name": "Preferred_Topic_Analytics__c",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
    Preferred_Topic_NetworkingADC__c: {
        "label": "Preferred_Topic_NetworkingADC__c",
        "show": true,
        "id": "Preferred_Topic_NetworkingADC__c",
        "name": "Preferred_Topic_NetworkingADC__c",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
    Preferred_Topic_SDWan__c: {
        "label": "Preferred_Topic_SDWan__c",
        "show": true,
        "id": "Preferred_Topic_SDWan__c",
        "name": "Preferred_Topic_SDWan__c",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
    Preferred_Topic_VirtualAppsDesktops__c: {
        "label": "Preferred_Topic_VirtualAppsDesktops__c",
        "show": true,
        "id": "Preferred_Topic_VirtualAppsDesktops__c",
        "name": "Preferred_Topic_VirtualAppsDesktops__c",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
    Marketing_Suspended_30_Days__c: {
        "label": "Suspend communication for 30 days.",
        "show": true,
        "id": "Marketing_Suspended_30_Days__c",
        "name": "Marketing_Suspended_30_Days__c",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
    Unsubscribed: {
        "label": "Suspend communication for 30 days.",
        "options": [
            "",
            {
                "value": "Yes",
                "text": "Yes"
            },
            {
                "value": "No",
                "text": "No"
            }
        ],
        "show": true,
        "id": "unsubscribed",
        "name": "unsubscribed",
        "validation": {
            "required": false,
            "regex": {}
        },
        "stateClass": {
            "error": false,
            "hasValue": false
        },
        "domElements": {
            "requiredIndicator": ""
        }
    },
}


/** Field and Schema Configuration */
const nonRequired = ["Job_Title__c", "Company_Self_Reported__c", "department", "Preferred_Language__c"]
const removeFields = ["programName", "source", "reason", "lookupField", "userAgent", "leadStatus", "webPage", "Direct_Mail_OK__c"]

//all Y/N Fields used for cleanup
const yesNoFields = [
    'Email_Blast_OK__c',
    'OK_to_Call__c',
    'Marketing_Suspended_30_Days__c',
    'Unsubscribed',
    'Preferred_Topic_Workspace__c',
    'Preferred_Topic_Analytics__c',
    'Preferred_Topic_NetworkingADC__c',
    'Preferred_Topic_SDWan__c',
    'Preferred_Topic_VirtualAppsDesktops__c'
]

export class PreferenceCenter extends SmartForm {

    /**
     * Assign default values and states
     * @private
     */
    _setDefaults() {

        //Fix non-required fields in schema
        nonRequired.map(f => {
            this.data.schema.config[f].validation.required = false
            this.data.schema.config[f].domElements.requiredIndicator = ''
        })

        //add fields to field map
        Object.assign(this.data.fields, this.data.defaults)

        //Remove any fields you don't want
        removeFields.map(f => delete this.data.fields[f])
    }

    sendData(endpoint, data, callback) {
        data = this.cleanFields(data)
        submitData(endpoint, data, callback)
    }

    cleanFields(data) {

        //Remove Fields we don't use in PrefCenter
        removeFields.map(f => delete data[f])

        //Make sure all values are either Yes or No
        yesNoFields.map(f => data[f] = data[f] === "Yes" ? "Yes" : "No")

        //Uppercase the first letter of every field, this is because MKTO forms use SOAP names, which are all uppercased
        data = Object.keys(data).reduce((a, f) => {
            let fixed = f.charAt(0).toUpperCase() + f.slice(1)
            a[fixed] = data[f]
            return a
        }, {})

        //remove other fields that don't have any info in them
        data = Object.keys(data)
            .filter(k => data[k] && data[k].length > 0)
            .reduce((a, v) => {
                a[v] = data[v].trim()
                return a
            }, {})

        return data
    }

    /**
     * removing all gdpr behaviour on preference center forms
     * @private
     */
    _checkGDPR(){
        return
    }

}

